import styled from 'styled-components'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const Overlay = styled.div<{ visible: boolean }>`
  position: fixed;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.21);
  z-index: 3000;
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
`

export const CloseButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  border-radius: 50%;
  color: ${(props) => props.theme.colors.greyDark};
  display: flex;
  height: 60px;
  justify-content: center;
  padding: 0px;
  position: absolute;
  right: 0px;
  top: 0px;
  transition: background-color 0.3s ease-in;
  width: 60px;

  &:hover {
    background-color: ${FantaTheme.colors.skyLight};
  }
`

export const DrawerWrapper = styled.div`
  ${AspiraStack};
  position: relative;
  background-color: ${(props) => props.theme.colors.white};
  margin: ${(props) => props.theme.spacing.sm};
  padding: 24px;
  @media (max-width: 600px) {
    width: 100%;
    height: 100%;
    padding: 12px;
  }
`

export const DrawerContent = styled.div`
  height: 100%;
`

export const drawerStyle: React.CSSProperties = {
  transitionProperty: 'visibility, opacity, transform',
  transitionDuration: '300ms',
  transitionTimingFunction: 'ease-in-out',
  boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  zIndex: 3000,
}
